import { useCallback } from "react";
import { useAtomValue } from "jotai/utils";

import { DataFilter } from "interfaces";
import DataFilters from "ui-components/Data-Filters/Create-Filter-List";

import {
  fileColTypes,
  useFetchDataFile,
  useFetchDataFileStats,
} from "modules/data-files/api";

interface Props {
  fileId: string;
  title?: string;
  filters: DataFilter.Filter[];
  filtersForStats?: DataFilter.Filter[];
  updateFilters: (filters: DataFilter.Filter[]) => unknown;
  name?: string;
  columnsToInclude?: string[];
  colTypes?: {
    [col: string]: "float" | "char" | "date" | "int" | "numeric" | "time";
  };
  className?: string;
}

const Filters = ({
  fileId,
  title,
  filters,
  filtersForStats,
  updateFilters,
  name,
  columnsToInclude,
  colTypes,
  className,
}: Props) => {
  const { data: dataFile } = useFetchDataFile(fileId, true);

  const types = useAtomValue(fileColTypes(fileId));
  const stats = useFetchDataFileStats(fileId, filtersForStats);

  const currentFilters = (filters || []).filter((f) =>
    dataFile?.columns?.includes(f.column)
  );

  const setFilters = useCallback(
    (newFilters: DataFilter.Filter[]) => {
      const nonFileFilters = (filters || []).filter(
        (f) => !dataFile?.columns?.includes(f.column)
      );
      if (nonFileFilters.length >= 1) {
        updateFilters([...newFilters, ...nonFileFilters]);
      } else {
        updateFilters(newFilters);
      }
    },
    [filters, dataFile, updateFilters]
  );

  if (!dataFile) {
    return null;
  }

  const columns =
    Array.isArray(columnsToInclude) && columnsToInclude.length >= 1
      ? dataFile.columns?.filter((c) => columnsToInclude.includes(c))
      : dataFile.columns;

  const columnsForFiltering = columns.filter((s) =>
    stats[s] ? stats[s].count >= 1 : true
  );

  if ((columnsForFiltering || []).length === 0) {
    return null;
  }

  return (
    <div className={className}>
      {title && <p className="mb-2 pb-2 font-bold text-xl">{title}</p>}
      <DataFilters
        name={name}
        columns={columnsForFiltering || []}
        columnTypes={colTypes || types || {}}
        stats={stats}
        existingFilters={currentFilters}
        onFilterChange={setFilters}
      />
    </div>
  );
};

export default Filters;
